/**
 * @generated SignedSource<<cb001e02ef3e7c3f5c1cd696f187bae1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useShouldShowSimilarSoldItems_item$data = {
  readonly categoryL2?: ReadonlyArray<{
    readonly key: string | null;
  } | null> | null;
  readonly pricingGuidance?: {
    readonly maxAmount: {
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
    } | null;
    readonly minAmount: {
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
    } | null;
    readonly price: {
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
    } | null;
  } | null;
  readonly vertical?: VerticalType | null;
  readonly " $fragmentType": "useShouldShowSimilarSoldItems_item";
};
export type useShouldShowSimilarSoldItems_item$key = {
  readonly " $data"?: useShouldShowSimilarSoldItems_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShouldShowSimilarSoldItems_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpSimilarSoldItemsModuleVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShouldShowSimilarSoldItems_item",
  "selections": [
    {
      "condition": "isPdpSimilarSoldItemsModuleVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vertical",
          "storageKey": null
        },
        {
          "alias": "categoryL2",
          "args": [
            {
              "kind": "Literal",
              "name": "level",
              "value": 2
            }
          ],
          "concreteType": "Category",
          "kind": "LinkedField",
          "name": "getCategoriesByLevel",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            }
          ],
          "storageKey": "getCategoriesByLevel(level:2)"
        },
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "buyerId",
                  "variableName": "userId"
                },
                {
                  "kind": "Literal",
                  "name": "isBuyerEstimateEnabled",
                  "value": true
                },
                {
                  "kind": "Variable",
                  "name": "isTrade",
                  "variableName": "isTrade"
                },
                {
                  "kind": "Variable",
                  "name": "priceBookName",
                  "variableName": "priceBookName"
                },
                {
                  "kind": "Variable",
                  "name": "userCountryCode",
                  "variableName": "userCountryCode"
                }
              ],
              "concreteType": "PricingGuidance",
              "kind": "LinkedField",
              "name": "pricingGuidance",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "price",
                  "plural": false,
                  "selections": (v0/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "minAmount",
                  "plural": false,
                  "selections": (v0/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "maxAmount",
                  "plural": false,
                  "selections": (v0/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "af8ca2df46eef5ec9e5c96000965f03f";

export default node;
